require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
require('../../modules/es.promise');
require('../../modules/es.promise.finally');

module.exports = require('../../internals/path').Promise;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/promise/index.js
// module id = 192
// module chunks = 0